// utils/toast.ts
import { toast } from "react-toastify";
import { ConfirmToast } from "../component/notification/notifications";

export const showConfirm = (
  message: string,
  onConfirm: () => void,
  onCancel?: () => void
) => {
  toast(
    <ConfirmToast
      message={message}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />,
    {
      closeButton: false,
    }
  );
};